import {Component, OnDestroy, OnInit} from '@angular/core';
import {CustomFormControl} from '../custom-form-control';
import {Observable, Subject, Subscription} from 'rxjs';
import {Select, Store} from '@ngxs/store';
import {TranscoderActions} from '../../../../state/transcoder/transcoder.actions';
import {debounceTime} from 'rxjs/operators';
import {DEBOUNCE_TIME} from '../../../../helpers/form.helper';
import {TranscoderState} from '../../../../state/transcoder/transcoder.state';
import {TranscoderSimple} from '../../../../models/transcoder.model';

@Component({
    selector: 'app-autocomplete-transcoder-index',
    templateUrl: './autocomplete-transcoder-index.component.html'
})
export class AutocompleteTranscoderIndexComponent extends CustomFormControl implements OnInit, OnDestroy {
    @Select(TranscoderState.fieldList) suggestions$: Observable<TranscoderSimple[]>;

    DROPDOWN_CLASS = 'app-autocomplete-dropdown';

    private subscriptions: Subscription = new Subscription();
    indexSearch$: Subject<any> = new Subject();

    constructor(private store: Store) {
        super();
    }

    ngOnInit(): void {
        this.subscriptions.add(
            this.indexSearch$
                .pipe(debounceTime(DEBOUNCE_TIME))
                .subscribe(
                    (indexSearch: string) => {
                        if (indexSearch) {
                            this.store.dispatch(new TranscoderActions.SearchIndex(indexSearch));
                        } else {
                            this.store.dispatch(new TranscoderActions.SetFieldList([]));
                        }
                    }
                )
        );
        if (this.control.value) {
            this.store.dispatch(new TranscoderActions.SetFieldList([{...this.control.value}]));
        }
    }

    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }

    search(indexSearch: string) {
        this.indexSearch$.next(indexSearch);
    }

    compareWith = (o1: any, o2: any) => {
        return o1?.index === o2?.index;
    };

    handleOpenChange(open: boolean) {
        if (!open) {
            // fix - when NzNotificationService displays message select dropdown was hidden only on hover instead of click-away
            Array.from(document.getElementsByClassName(this.DROPDOWN_CLASS)).forEach(dropdown => {
                while (dropdown.firstChild) {
                    dropdown.firstChild.remove();
                }
            });
        }
    }
}
